// import VConsole from 'vconsole';
import qrCode3 from '@/components/qrCode3.vue';
export default {
  name: 'scan',
  data() {
    return {
      showQrcode: false,
      isIos: false
    };
  },
  components: {
    qrCode3
  },
  created() {},
  mounted() {
    // new VConsole();
    this.isIos = this.isIOS();
    console.log(this.isIos, 'isIos');
    if (this.isIos) return;
    this.showQrcode = true;
  },
  methods: {
    isIOS() {
      const ua = navigator.userAgent.toLowerCase();
      return /iphone|ipad|ipod/.test(ua);
    }
  }
};